import { render, staticRenderFns } from "./newsletterTypeDialog.vue?vue&type=template&id=62945c65&scoped=true&"
import script from "./newsletterTypeDialog.vue?vue&type=script&lang=js&"
export * from "./newsletterTypeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62945c65",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VHover } from 'vuetify/lib/components/VHover';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VHover,VImg,VSheet})
